import { AuthActionTypes } from "./constants"
import { User } from "types/auth"

export type AuthActionType = {
  type: AuthActionTypes.AUTHENTICATE
  payload: {} | string
}

export const authenticate = (user: User): AuthActionType => ({
  type: AuthActionTypes.AUTHENTICATE,
  payload: user,
})
